<div class="row mt-5">
  <div class="col-12 text-center">
    <h3 id="title">
      ขอตรวจสอบ
    </h3>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/investigate/investigate.component.html